import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { EntityTypeConfigKeys } from '@utils/entityViewConfig';
import { APP_PATHS, Permission } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/policy-violations/{-$id}/')({
  staticData: {
    path: 'policy-violations',
    key: EntityTypeConfigKeys.PolicyViolation,
  },
  validateSearch: zodValidator(withDefaults(schema.POLICY_VIOLATIONS, defaultFilter)),
  search: {
    middlewares: [stripSearchParams(defaultFilter)],
  },
  beforeLoad: ({ context, preload }) => {
    const isAllowed = context.userPermissions.hasAllowedPermission({
      path: 'policy-violations',
      app: APP_PATHS.ASSETS,
      permission: Permission.READ,
    });
    context.validatePermissions({ isAllowed, preload });
  },
});
